import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PhxMobileSelectComponent } from './mobile-select.component';
import { PhxSelectModule } from './../select/select.module';
import { PhxDialogModule } from '../dialog/phx-dialog.module';
import { FormsModule } from '@angular/forms';
import { PhxIconModule } from './../icon/icon.module';
import { PhxInputModule } from './../input/phx-input.module';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';

@NgModule({
  imports: [CommonModule, FormsModule, PhxSelectModule, PhxDialogModule, PhxIconModule, PhxIconButtonModule, PhxInputModule, PhxTranslationsRootModule],
  declarations: [PhxMobileSelectComponent],
  exports: [PhxMobileSelectComponent],
})
export class PhxMobileSelectModule {}
